// Constantes para el formulario de categorías presupuestarias

export const formBudgetCategoryManagementNaming = {
  NEW_BUDGET_CATEGORY_MANAGEMENT_FORM: 'NEW_BUDGET_CATEGORY_MANAGEMENT_FORM',
};

// Valores por defecto para el formulario
export const defaultBudgetCategoryValues = {
  code: '',
  name: '',
  color: '', // Se establecerá dinámicamente con el tema
  isActive: true,
  isCreated: true,
  id: '',
};

// Colores predefinidos para las categorías (usando tema)
export const getPredefinedColors = (theme: any) => [
  { value: theme.colors.blue, label: 'Azul' },
  { value: theme.colors.red, label: 'Rojo' },
  { value: theme.colors.green, label: 'Verde' },
  { value: theme.colors.gold, label: 'Amarillo' },
  { value: theme.colors.purple, label: 'Púrpura' },
  { value: theme.colors.lightCoralRed, label: 'Naranja' },
  { value: theme.colors.lightPink, label: 'Rosa' },
  { value: theme.colors.garnet, label: 'Violeta' },
  { value: theme.colors.forestGreen, label: 'Teal' },
  { value: theme.colors.darkGrey, label: 'Índigo' },
  { value: theme.colors.darkBrickRed, label: 'Marrón' },
  { value: theme.colors.mossGreen, label: 'Esmeralda' },
  { value: theme.colors.mediumGrey, label: 'Gris' },
  { value: theme.colors.lightCoralRed, label: 'Rojo claro' },
  { value: theme.colors.DustyRose, label: 'Violeta claro' },
  { value: theme.colors.goldSoft, label: 'Ámbar' },
];

// Colores legacy para compatibilidad (deprecated - usar getPredefinedColors)
export const PREDEFINED_COLORS = [
  { value: '#2563EB', label: 'Azul' },
  { value: '#DC2626', label: 'Rojo' },
  { value: '#16A34A', label: 'Verde' },
  { value: '#CA8A04', label: 'Amarillo' },
  { value: '#9333EA', label: 'Púrpura' },
  { value: '#C2410C', label: 'Naranja' },
  { value: '#BE185D', label: 'Rosa' },
  { value: '#7C3AED', label: 'Violeta' },
  { value: '#0F766E', label: 'Teal' },
  { value: '#4338CA', label: 'Índigo' },
  { value: '#92400E', label: 'Marrón' },
  { value: '#059669', label: 'Esmeralda' },
  { value: '#6B7280', label: 'Gris' },
  { value: '#EF4444', label: 'Rojo claro' },
  { value: '#8B5CF6', label: 'Violeta claro' },
  { value: '#F59E0B', label: 'Ámbar' },
];
